import addPlaceholder from '../assets/add-placeholder.jpg';
import viewerPlaceholder from '../assets/banner-placeholder.png';
import qrImage from '../assets/qr2-page.png';
import storePages from '../assets/store-pages2.png';
import customDesign from '../assets/custom-design.png';
import controlImage from '../assets/user-friendly.jpg';

/**
 * Non-translatable application config: images, contact values, identifiers,
 * structural metadata for marketing sections.
 *
 * All user-visible text now lives in `shared/translations/{en,ar}.js` and is
 * consumed via `useTranslation()`.
 */
export const appConfig = {
    brand: 'Storec',
    contact: {
        addressValue: '',
        emailValue: 'info@storec.app',
        phoneValue: '+96170691958',
        whatsAppValue: '+96170691958',
        workingHoursValue: '24/7',
    },
    placeholders: {
        feedback: addPlaceholder,
        carouselAdmin: addPlaceholder,
        carouselViewer: viewerPlaceholder,
        banner: addPlaceholder,
    },
    homeFeedback: {
        backgroundColor: '#9a0000',
    },
    featureItems: [
        {
            id: 'designStore',
            image: customDesign,
            available: true,
            keyPointIds: ['theme', 'category', 'branding'],
        },
        {
            id: 'completePresence',
            image: storePages,
            available: true,
            keyPointIds: ['catalog', 'about', 'contact'],
        },
        {
            id: 'growBusiness',
            image: qrImage,
            available: true,
            keyPointIds: ['qr', 'feedback', 'visibility'],
        },
        {
            id: 'effortlessControl',
            image: controlImage,
            available: true,
            keyPointIds: ['ui', 'updates', 'efficiency'],
        },
    ],
    pricingPlans: [
        {
            id: 'unlimited',
            price: '$95',
            popular: true,
            available: true,
            keyPointIds: [
                'branch', 'products', 'catalog', 'branding', 'qr',
                'pages', 'maps', 'feedback', 'social', 'support',
            ],
        },
        {
            id: 'business',
            price: '$180',
            available: false,
            keyPointIds: [
                'branches', 'products', 'catalog', 'branding', 'qr',
                'pages', 'maps', 'feedback', 'social', 'prioritySupport',
            ],
        },
        {
            id: 'vip',
            price: '$250',
            available: false,
            keyPointIds: ['businessFeatures', 'management', 'optimization', 'support'],
        },
        {
            id: 'extraFeatures',
            available: true,
            useCheckIcons: true,
            keyPointIds: ['menuSections', 'multiLanguage'],
        },
    ],
};

/**
 * @deprecated Use `appConfig` for data and `useTranslation()` for text.
 *   Kept as a thin alias for any consumer that may still reference it.
 */
export const useStrings = appConfig;

export default appConfig;
